import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';

var _excluded = ["as"];
var Group = /*#__PURE__*/forwardRef(function Group(props, ref) {
  var _props$as = props.as,
      Tag = _props$as === void 0 ? 'span' : _props$as,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var className = cn('yt-group', props.className);
  return createElement(Tag, Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }));
});

export { Group };
//# sourceMappingURL=Group.js.map
